import { render, staticRenderFns } from "./BuyInstruction.vue?vue&type=template&id=15396d2e&scoped=true&"
import script from "./BuyInstruction.vue?vue&type=script&lang=js&"
export * from "./BuyInstruction.vue?vue&type=script&lang=js&"
import style0 from "./BuyInstruction.vue?vue&type=style&index=0&id=15396d2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15396d2e",
  null
  
)

export default component.exports